import { Box, Typography, type SxProps, type Theme } from '@mui/material'

type Variante = 'padrao' | 'clara'

/**
 * Assinatura visual do painel: a MARCA OFICIAL da ARSAL (logo institucional)
 * ao lado do nome do produto (GEFSAN · Saneamento). Substitui o losango-com-gota
 * antigo — a identidade agora e a da agencia.
 *
 * `variante='clara'` inverte o logo para branco, para uso sobre o azul
 * institucional (painel da tela de login). `compacta` mostra so o logo.
 */
export function Marca({
  sx,
  compacta = false,
  variante = 'padrao',
}: {
  sx?: SxProps<Theme>
  compacta?: boolean
  variante?: Variante
}) {
  const clara = variante === 'clara'

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, ...sx }}>
      <Box
        component="img"
        src="/logo-arsal.png"
        alt="ARSAL — Agência Reguladora de Serviços Públicos do Estado de Alagoas"
        sx={{
          height: 38,
          width: 'auto',
          display: 'block',
          flexShrink: 0,
          // sobre o azul institucional o logo azul some: invertemos para branco
          ...(clara && { filter: 'brightness(0) invert(1)' }),
        }}
      />
      {!compacta && (
        <Box
          sx={{
            minWidth: 0,
            pl: 2.5,
            borderLeft: '1px solid',
            borderColor: clara ? 'rgba(255, 255, 255, 0.4)' : 'divider',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              lineHeight: 1.1,
              letterSpacing: '-0.2px',
              color: clara ? 'common.white' : 'text.primary',
            }}
          >
            GEFSAN
          </Typography>
          <Typography
            variant="caption"
            sx={{ lineHeight: 1, color: clara ? 'rgba(255, 255, 255, 0.75)' : 'text.secondary' }}
          >
            Saneamento
          </Typography>
        </Box>
      )}
    </Box>
  )
}
